module.exports = __webpack_public_path__ + "static/matterfarm-389e70660025b369fc3163a1e1878d31.png";